import * as i0 from '@angular/core';
import * as i1 from './popover.module';
import * as i2 from './popover';
export const NgbPopoverModuleNgFactory:i0.NgModuleFactory<i1.NgbPopoverModule> = (null as any);
var _decl0_0:i2.NgbPopover = (<any>(null as any));
var _decl0_1:i2.NgbPopoverWindow = (<any>(null as any));
var _decl0_2:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_3:i0.ElementRef<any> = (<any>(null as any));
function _View_NgbPopoverWindow_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NgbPopoverWindow_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_1.title;
  currVal_0;
}
